import { token, DividerHorizontal } from '@ferreri/prever-component-lib';
import styled from '@emotion/styled';
import { DependentLimitInfo } from './DependentLimitInfo';
import { SiblingGroupLabels } from './SiblingGroupLabels';
import { SubscriptionRules } from './SubscriptionRules';
import {
  ExtendedGroupType,
  SubscriptionDependentRuleType,
} from './rules.types';

type DependentInfoProps = {
  siblingGroup: ExtendedGroupType[];
  kinship: string;
  maxQuantity: number;
  maxQuantityAdditional: number;
  subscriptionRules: SubscriptionDependentRuleType[];
  hasAdditionalDependentGlobal: boolean;
};

export const DependentInfo = (props: DependentInfoProps) => {
  return (
    <>
      <KinshipWrapper>
        <SiblingGroupLabels
          siblingGroups={props.siblingGroup}
          mainKinshipName={props.kinship}
        />
        <DependentLimitInfo
          slug={props.kinship}
          maxQuantity={props.maxQuantity}
          maxQuantityAdditional={props.maxQuantityAdditional}
          hasAdditionalDependentGlobal={props.hasAdditionalDependentGlobal}
        />
      </KinshipWrapper>
      <DividerHorizontal />
      <SubscriptionRules subscriptionRules={props.subscriptionRules} />
    </>
  );
};

const KinshipWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: ${token.spacing.spacingXxxSmall};
`;
